import React, { memo, useCallback } from 'react';
import './multi-select-list.scss';
import { MultiSelectOption } from './_multi-select-option';

interface IMultiSelectListProps<TItem> {
    items: TItem[];
    value: TItem[];
    onChange: (newValue: TItem) => void;
    disabled: TItem[];
    nameProperty: string;
    keyProperty: string;
}

const MultiSelectList = memo((props: IMultiSelectListProps<object & { hoverLabel?: string }>) => {
    const { items, value, disabled = [], onChange, keyProperty, nameProperty } = props;

    const onOptionToggle = useCallback((isSelected, selectionItem) => () =>
        onChange(
            isSelected ? value.filter(x => x[keyProperty] !== selectionItem[keyProperty]) : [...value, selectionItem]
        ), [value]);

    const includes = useCallback((list, selectionItem) => list.some(el => el[keyProperty] === selectionItem[keyProperty]), []);

    return (
        <div className='multi-select-list'>
            {items.map(selectionItem => {
                const name = selectionItem[nameProperty];
                const isSelected = includes(value, selectionItem);
                const isDisabled = includes(disabled, selectionItem);

                return <MultiSelectOption
                    key={selectionItem[keyProperty]}
                    isSelected={isSelected}
                    isDisabled={isDisabled}
                    name={name}
                    onClick={onOptionToggle(isSelected, selectionItem)}
                    hoverLabel={selectionItem.hoverLabel}
                />;
            })}
        </div>
    );
});

export { MultiSelectList, IMultiSelectListProps };
